import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import LotForm from "components/agro/lots/LotForm";
import { updateLot } from "graphql/mutations";
import { getLot } from "graphql/queries";

const LotUpdateForm = ({ lotId, onSuccess }) => {
  const navigate = useNavigate();
  const [lot, setLot] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        farmID,
        lotNumber,
        name,
        sizeM2,
        perimeterM,
        location,
        status,
        cropTypeId,
        cropUnits,
        performedById,
        quantity,
        photoEvidence,
        blueprints,
        description,
        companyID,
      } = valuesParam;

      await API.graphql({
        query: updateLot.replaceAll("__typename", ""),
        variables: {
          input: {
            id: lotId,
            farmID,
            lotNumber:
              lotNumber === undefined || lotNumber === ""
                ? null
                : Number(lotNumber),
            name,
            sizeM2:
              sizeM2 === undefined || sizeM2 === "" ? null : Number(sizeM2),
            perimeterM:
              perimeterM === undefined || perimeterM === ""
                ? null
                : Number(perimeterM),
            location,
            status,
            cropTypeId,
            cropUnits,
            performedById,
            quantity:
              quantity === undefined || quantity === ""
                ? null
                : Number(quantity),
            photoEvidence,
            blueprints,
            description,
            companyID,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/agro/lots");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchLot(id) {
    try {
      const lotData = await API.graphql(graphqlOperation(getLot, { id }));
      const lotItem = lotData.data.getLot;
      if (!lotItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/agro/lots");
        return;
      }
      setLot({
        ...lotItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchLot(lotId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotId]);

  if (!lot) return <Loader />;

  return (
    <div>
      <LotForm onSubmit={onSubmit} type="update" initialValues={lot} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Lote",
    successUpdated: "Lote actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el lote",
    },
  },
});

export default LotUpdateForm;
